// 演出管理路由
export default {
    path: 'activityManage',
    component: () => import('@/components/RouterView'),
    redirect: '/activityManage/activity/list',
    meta: {title: '演出管理'},
    children: [
        {
            path: 'activity',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/activity/list',
            meta: {activePage: '/activityManage/activity/list'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/activityManage/activity/list'),
                    meta: {title: '演出列表'}
                },
                {
                    path: 'edit/baseInfo/:id',
                    component: () => import('@/views/activityManage/activity/edit/baseInfo'),
                    meta: {title: '演出基本信息'},
                    props: true
                },
                {
                    path: 'edit/changeNotice/:id',
                    component: () => import('@/views/activityManage/activity/edit/changeNotice'),
                    meta: {title: '演出变动通知'},
                    props: true
                },
				{
				    path: 'edit/updateLog/:id',
				    component: () => import('@/views/activityManage/activity/edit/updateLog'),
				    meta: {title: '演出修改日志'},
				    props: true
				},
                {
                    path: 'edit/session/:id',
                    component: () => import('@/views/activityManage/activity/edit/session'),
                    meta: {title: '演出场次设置'},
                    props: true
                },
                {
                    path: 'edit/finance/:id',
                    component: () => import('@/views/activityManage/activity/edit/finance'),
                    meta: {title: '演出财务信息'},
                    props: true
                },
                {
                    path: 'edit/approval/:id',
                    component: () => import('@/views/activityManage/activity/edit/approval.vue'),
                    meta: {title: '演出报批信息'},
                    props: true
                },
                {
                    path: 'edit/presentTicket/:id',
                    component: () => import('@/views/activityManage/activity/edit/presentTicket'),
                    meta: {title: '演出赠票管理'},
                    props: true
                },
				{
				    path: 'edit/lackTicket/:id',
				    component: () => import('@/views/activityManage/activity/edit/lackTicket'),
				    meta: {title: '票品登记'},
				    props: true
				},
                {
                    path: 'edit/activityTicketPrices/:id',
                    component: () => import('@/views/activityManage/activity/edit/activityTicketPrices'),
                    meta: {title: '演出售票设置'},
                    props: true
                },
                {
                    path: 'edit/sessionsTicketPrices/:id',
                    component: () => import('@/views/activityManage/activity/edit/sessionsTicketPrices'),
                    meta: {title: '场次售票设置'},
                    props: true
                },
                {
                    path: 'edit/throughTicketPrices/:id',
                    component: () => import('@/views/activityManage/activity/edit/throughTicketPrices'),
                    meta: {title: '通票设置'},
                    props: true
                },
                {
                    path: 'edit/thirdTicket/:id',
                    component: () => import('@/views/activityManage/activity/edit/thirdTicket'),
                    meta: {title: '主办自有售票渠道数据'},
                    props: true
                },
				{
				    path: 'edit/thirdList/:id',
				    component: () => import('@/views/activityManage/activity/edit/thirdList'),
				    meta: {title: '外部销售'},
				    props: true
				},
				{
				    path: 'edit/activityDashboard/:id',
				    component: () => import('@/views/activityManage/activity/edit/activityDashboard'),
				    meta: {title: '数据统计'},
				    props: true
				},	
    //             {
				//     path: 'edit/seatConfig/:id',
				//     component: () => import('@/views/activityManage/activity/edit/seatConfig'),
				//     meta: {title: '选座设置'},
				//     props: true
				// },
				{
				    path: 'edit/batchUpdate/:id',
				    component: () => import('@/views/activityManage/activity/edit/batchUpdate'),
				    meta: {title: '批量更新场次信息'},
				    props: true
				},
				{
				    path: 'edit/sort/:id',
				    component: () => import('@/views/activityManage/activity/edit/sort.vue'),
				    meta: {title: '演出其他设置'},
				    props: true
				},
				{
				    path: 'edit/souvenir/:id',
				    component: () => import('@/views/activityManage/activity/edit/souvenir.vue'),
				    meta: {title: '纪念票设置'},
				    props: true
				},
				
            ]
        },
        {
            path: 'theme',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/theme/list',
            meta: {title: '主题管理', activePage: '/activityManage/theme/list'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/activityManage/theme/list'),
                    meta: {title: '主题管理列表'}
                },
                {
                    path: 'manage/:id',
                    component: () => import('@/views/activityManage/theme/showManage'),
                    name: 'theme-manage',
                    meta: {title: '主题详情'},
                    props: true
                }
            ]
        },
        {
            path: 'touring',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/touring/list',
            meta: {title: '巡演管理', activePage: '/activityManage/touring/list'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/activityManage/touring/list'),
                    meta: {title: '巡演管理列表'}
                },
                {
                    path: 'manage/:id',
                    component: () => import('@/views/activityManage/touring/touringManage'),
                    name: 'touring-manage',
                    meta: {title: '巡演详情'},
                    props: true
                }
            ]
        },
        {
            path: 'editVerify',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/editVerify/list',
            meta: {title: '演出修改审核', activePage: '/activityManage/editVerify/list'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/activityManage/editVerify/list'),
                    meta: {title: '演出修改审核列表'}
                },
                {
                    path: 'detail/:recordId',
                    component: () => import('@/views/activityManage/editVerify/detail'),
                    name: 'edit-verify-detail',
                    meta: {title: '演出修改审核详情'},
                    props: true
                }
            ]
        },
        {
            path: 'onlineVerify',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/onlineVerify/list',
            meta: {title: '演出上线审核', activePage: '/activityManage/onlineVerify/list'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/activityManage/onlineVerify/list'),
                    meta: {title: '演出上线审核列表'}
                },
                {
                    path: 'verify/:id',
                    component: () => import('@/views/activityManage/onlineVerify/verify'),
                    meta: {title: '审核'},
                    props: true
                }
            ]
        },
        {
            path: 'order',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/order/list',
            meta: {title: '订单管理', activePage: '/activityManage/order/list'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/activityManage/order/list'),
                    meta: {title: '订单列表'}
                },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/activityManage/order/edit'),
                    meta: {title: '订单详情'},
                    props: true
                }
            ]
        },
		{
		    path: 'cancelOrderVerify',
		    component: () => import('@/components/RouterView'),
		    redirect: '/activityManage/cancelOrderVerify/list',
		    meta: {title: '订单取消审核', activePage: '/activityManage/cancelorderVerify/list'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/activityManage/cancelorderVerify/list'),
		            meta: {title: '订单取消审核列表'}
		        },
		        // {
		        //     // path: 'edit/:id',
		        //     // component: () => import('@/views/activityManage/cancelorderVerify/edit'),
		        //     // meta: {title: '订单详情'},
		        //     // props: true
		        // }
		    ]
		},
        // {
        //     path: 'repeatOrder',
        //     component: () => import('@/components/RouterView'),
        //     redirect: '/activityManage/repeatOrder/list',
        //     meta: {title: '重复支付订单'},
        //     children: [
        //         {
        //             path: 'list',
        //             component: () => import('@/views/activityManage/repeatOrder/list'),
        //             meta: {title: '订单列表'}
        //         },
        //         {
        //             path: 'edit/:id',
        //             component: () => import('@/views/activityManage/repeatOrder/edit'),
        //             meta: {title: '订单详情'},
        //             props: true
        //         }
        //     ]
        // },
        {
            path: 'refundTicketAudit',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/refundTicketAudit/list',
            meta: {title: '退票审核'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/activityManage/refundTicketAudit/list'),
                    meta: {title: '退票审核列表'}
                },
				{
					path: 'aftersales',
					component: () => import('@/views/activityManage/refundTicketAudit/aftersales/set'),
					meta: {title: '配置售后原因'},
					props: true
				}
            ]
        },		
		{
		    path: 'hot',
		    component: () => import('@/components/RouterView'),
		    redirect: '/activityManage/hot/list',
		    meta: {title: '演出热度'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/activityManage/hot/list'),
		            meta: {title: '演出热度列表'}
		        }
		    ]
		},		
		{
		    path: 'activityChange',
		    component: () => import('@/components/RouterView'),
		    redirect: '/activityManage/activityChange/list',
		    meta: {title: '门票迁移'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/activityManage/activityChange/list'),
		            meta: {title: '门票迁移'}
		        }
		    ]
		},
		
        {
            path: 'showPlan',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/showPlan/list',
            meta: {title: '无批文演出展示计划'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/activityManage/showPlan/list'),
                    meta: {title: '无批文演出展示计划列表'}
                }
            ]
        },
        {
            path: 'updateNotify',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/updateNotify/list',
            meta: {title: '待通知演出变动'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/activityManage/updateNotify/list'),
                    meta: {title: '待通知演出变动列表'}
                }
            ]
        },
        {
            path: 'cancelActivityAudit',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/cancelActivityAudit',
            meta: {title: '取消演出审核'},
            children: [
                {
                    path: '',
                    component: () => import('@/views/activityManage/cancelActivityAudit'),
                    meta: {title: '取消演出审核列表'}
                }
            ]
        },
        {
            path: 'activityPush',
            component: () => import('@/components/RouterView'),
            redirect: '/activityManage/activityPush',
            meta: {title: '待推送演出'},
            children: [
                {
                    path: '',
                    component: () => import('@/views/activityManage/activityPush/list'),
                    meta: {title: '待推送演出列表'}
                }
            ]
        },
		{
		    path: 'activityPushExport',
		    component: () => import('@/components/RouterView'),
		    redirect: '/activityManage/activityPushExport/list',
		    meta: {title: '演出三方推送导出'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/activityManage/activityPushExport/list'),
		            meta: {title: '演出三方推送导出'}
		        }
		    ]
		},
		{
		    path: 'invoice',
		    component: () => import('@/components/RouterView'),
		    redirect: '/activityManage/invoice/list',
		    meta: {title: '发票中心', activePage: '/activityManage/invoice/list'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/activityManage/invoice/list'),
		            meta: {title: '发票中心列表'}
		        },
		        // {
		        //     path: 'manage/:id',
		        //     component: () => import('@/views/activityManage/touring/touringManage'),
		        //     name: 'touring-manage',
		        //     meta: {title: '巡演详情'},
		        //     props: true
		        // }
		    ]
		},
		{
		    path: 'daping',
		    component: () => import('@/components/RouterView'),
		    redirect: '/activityManage/daping/list',
		    meta: { title: '对外数据看版'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/activityManage/daping/list'),
		            meta: {title: '音乐节数据看板', activePage:'/activityManage/daping'}
		        },
		        {
		            path: 'salelist',
		            component: () => import('@/views/activityManage/daping/salelist'),
		            meta: {title: '音乐节数据看板'}
		        },
				{
				    path: 'invitelist',
				    component: () => import('@/views/activityManage/daping/invitelist'),
				    meta: {title: '邀请函数据看板'}
				}
		    ]
		}        
    ]
};
